import { type ReportDateRange } from '@terros/common'

/** The rolling window a dashboard falls back to when nothing else is configured. */
export const DEFAULT_DASHBOARD_DATE_RANGE: ReportDateRange = { type: 'relative', value: 30, unit: 'days' }

/**
 * The baseline range a Home feed section's widgets inherit, and the range its
 * header picker displays: the range picked on the section itself, then the
 * page-level pick, then the dashboard's configured range, then the 30-day
 * default. Widgets carrying their own `dateRange` ignore all of this.
 */
export function getFeedSectionDateRange({
  sectionDateRange,
  homeDateRange,
  dashboardDateRange,
}: {
  sectionDateRange: ReportDateRange | undefined
  homeDateRange: ReportDateRange | undefined
  dashboardDateRange: ReportDateRange | undefined
}): ReportDateRange {
  return sectionDateRange ?? homeDateRange ?? dashboardDateRange ?? DEFAULT_DASHBOARD_DATE_RANGE
}
